import { PagesList } from '../components/Pages/PagesList';

import { useDepartmentStore } from '@/stores/department';

export const BotTelegramPagesView = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <PagesList department={department} />;
};
